//libs
import { styled } from '@nykaa/ui-components';
import BaseButton from '@nykaa/ui-components/Button';
import { SpotLoader } from '@nykaa/ui-components/Loader';

//components
import SizeOptionsBase from 'shared/components/SizeOptionsBottomSheet/SizeOptions';
import ImageV2 from 'shared/components/ImageV2/Image';

import { keyframes } from '@emotion/core';
import { truncate } from 'shared/styles/mixin';

const scaleIn = keyframes`
  0% {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
  }
  100% {
    top: -20px;
    left: -30px;
    right: -30px;
    bottom: -20px;
    opacity: 1;
  }
`;

export const DesktopContainer = styled.div<{ isSizeSelected?: boolean; isOutOfStock?: boolean }>`
  position: absolute;
  margin: auto;
  z-index: 4;
  animation-name: ${scaleIn};
  animation-duration: 0.4s;
  animation-fill-mode: forwards;
  background-color: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.textDecorative};
  box-shadow: ${({ theme }) => theme.elevations.shadow400};

  & .addToBagButtonContainer {
    height: 40px;
    ${({ theme, isSizeSelected }) =>
      !isSizeSelected &&
      `
      background-color:${theme.colors.surface};
      color:${theme.colors.textPrimary};
      &:not([disabled]):hover {
       background-color:${theme.colors.surface};
       color:${theme.colors.textPrimary};
      }
    `}
  }

  & .desktop-notify {
    margin-top: ${({ theme, isOutOfStock = false }) =>
      isOutOfStock ? theme.spacing.spacing60 : 0};

    & form {
      div:nth-child(2) {
        min-width: auto;
      }
    }
  }
`;

export const InnerContainer = styled.div`
  position: relative;
  height: 100%;
`;

export const SizeOptions = styled(SizeOptionsBase)<{ isScrolled?: boolean }>`
  width: auto;

  margin-bottom: ${({ theme }) => theme.spacing.spacing40};
  margin-top: 0;

  && .size-btn-container {
    min-width: unset;
    max-height: 190px;
    margin: unset;
    overflow-y: auto;

    &:first-of-type {
      padding-right: unset;
      padding-left: unset;
    }

    & .size-btn {
      padding-bottom: 0;
      margin-bottom: ${({ theme }) => theme.spacing.spacing40};
      gap: 0.5rem;

      & button {
        ${({ theme }) => theme.typography.bodySmall};
        padding: ${({ theme }) => `${theme.spacing.spacing20} ${theme.spacing.spacing80}`};
      }
    }
  }
`;

export const SizeSelectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  bottom: 8px;
  width: 100%;
  position: absolute;
  background-color: ${({ theme }) => theme.colors.surface};
  padding: ${({ theme }) =>
    `${theme.spacing.spacing40} ${theme.spacing.spacing40} 0 ${theme.spacing.spacing40}`};
`;

export const Title = styled.span`
  ${truncate};
  margin-bottom: ${({ theme }) => theme.spacing.spacing10};
  ${({ theme }) => theme.typography.subTitleMedium}
`;
export const SubTitle = styled.span`
  ${truncate};
  margin-bottom: ${({ theme }) => theme.spacing.spacing20};
  ${({ theme }) => theme.typography.bodyMedium}
`;
export const SelectSize = styled.div<{ isScrolled: boolean }>`
  margin: ${({ theme }) => theme.spacing.spacing60} -${({ theme }) => theme.spacing.spacing40} 0 -${({
      theme,
    }) => theme.spacing.spacing40};
  padding-left: ${({ theme }) => theme.spacing.spacing40};
  padding-right: ${({ theme }) => theme.spacing.spacing40};
  padding-bottom: ${({ theme }) => theme.spacing.spacing40};
  ${({ theme }) => theme.typography.buttonMedium};
  z-index: 1;
  ${({ isScrolled }) => isScrolled && `box-shadow:0px 4px 4px rgba(151, 151, 151, 0.16);`}
`;

export const Image = styled(ImageV2)`
  width: 100%;
  height: auto;
`;

export const SizeOptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const SizeOptionsInnerContainer = styled.div`
  overflow-x: hidden;
`;

export const MoveToBagButton = styled(BaseButton)`
  height: 40px;
  border-radius: ${({ theme }) => theme.borders.radius10};
`;

export const InverseLoader = styled(SpotLoader)`
  border-color: ${({ theme }) => theme.colors.surface}; ;
`;
